import {createContext} from "react"
import React from "react";
export const CustomerContext = createContext({})


const CustomerContextProvider = ({children}) => {
    return (
        <CustomerContext.Provider>
          {children}
        </CustomerContext.Provider>
      );
}

export default CustomerContextProvider